/* AM-URGENCY-VARIANT - una linea de urgencia por VARIANTE.

   Calca el mecanismo de claireandriley.com (<variant-inventory class="urgency-stock">):
   el Liquid imprime un <div data-am-urg-variant="ID"> por cada variante, todos con el
   atributo [hidden] menos el de la variante seleccionada. Este script cambia cual se ve
   cuando el cliente cambia de color o de talla.

   Va como ASSET y no como <script> inline porque los scripts inline dentro de un
   custom_liquid no se ejecutan en este storefront (solo el <style>). */

(function () {
  'use strict';

  function initWrap(wrap) {
    var bars = wrap.querySelectorAll('[data-am-urg-variant]');
    if (!bars.length) return;

    /* El input name="id" de OTRO producto (quick add, productos relacionados) no debe
       mandar sobre esta ficha: se busca solo dentro de la seccion del propio bloque. */
    var scope = wrap.closest('.shopify-section') || document;
    var ultimo = null;

    function idActual() {
      var f = scope.querySelector('input[name="id"]');
      return f ? String(f.value) : null;
    }

    function sync() {
      var id = idActual();
      if (!id || id === ultimo) return;

      var hay = false;
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].getAttribute('data-am-urg-variant') === id) { hay = true; break; }
      }
      if (!hay) return;          // id de otra ficha: no tocar nada

      ultimo = id;
      for (var j = 0; j < bars.length; j++) {
        if (bars[j].getAttribute('data-am-urg-variant') === id) bars[j].removeAttribute('hidden');
        else bars[j].setAttribute('hidden', '');
      }
    }

    sync();

    /* Dawn no actualiza el input al instante: reescribe el precio y los botones con la
       Section Rendering API. Por eso se reintenta unas cuantas veces tras el cambio. */
    function reintentar() {
      [0, 60, 200, 500, 900, 1500].forEach(function (t) { setTimeout(sync, t); });
    }

    document.addEventListener('change', reintentar, true);

    if (window.MutationObserver) {
      /* sync() sale solo si el id no cambio, asi que nuestras propias mutaciones
         de [hidden] no realimentan el observer. */
      new MutationObserver(sync).observe(scope, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['value']
      });
    }
  }

  function start() {
    var wraps = document.querySelectorAll('.am-urgency-buy');
    for (var i = 0; i < wraps.length; i++) initWrap(wraps[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
